import { createAction, props } from "@ngrx/store";
import { MessageData } from "@pgr-cla/cla-window";

export const actionItemNavigation = createAction(
  "[Claim Landing] Action Item Nagivation",
  props<{ event: MessageData }>()
);
